import utils from '@/mixins/utils.js'

export const dataFields = {
  'Responsável familiar': 'resp_fam',
  'Data de nascimento': {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== '' ? utils.methods.formatDate(value) : ''
    },
  },
  MA: 'micro_area',
  TRIA: {
    field: 'ult_tria',
    callback: (value) => {
      return value !== ''
        ? `${utils.methods.formatDate(
            value
          )} (${utils.methods.calculateTimeDifference(
            utils.methods.formatDate(value)
          )})`
        : ''
    },
  },
  Necessidade: 'inseguranca_alimentar',
}

export const chartOptions = {
  chart: {
    height: 300,
    type: 'line',
    zoom: {
      enabled: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  stroke: {
    curve: 'straight',
    width: 2,
  },
  title: {
    text: '',
    align: 'center',
  },
  grid: {
    row: {
      colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
      opacity: 0.5,
    },
  },
  xaxis: {
    // categories: ['01/2021', '02/2021', '03/2021', '04/2021', '05/2021', '06/2021', '07/2021', '08/2021', '09/2021', '10/2021', '11/2021', '12/2021']
    categories: [],
  },
  yaxis: {
    min: 0,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'center',
  },
  markers: {
    size: 5,
  },
  annotations: {
    yaxis: [
      {
        y: 70,
        y2: 100,
        borderColor: '',
        fillColor: '#b3ffb3',
        label: {
          text: '',
        },
      },
      {
        y: 0,
        y2: 69,
        borderColor: '',
        fillColor: '#ffcccc',
        label: {
          text: '',
        },
      },
    ],
  },
  colors: ['#008FFB', '#ff9933'],
}

export const municipioBarOptions = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      distributed: true,
      horizontal: true,
    },
  },
  dataLabels: {
    enabled: true,
    offsetX: 50,
    style: {
      fontSize: '12px',
      colors: ['#000000'],
    },
    formatter: function (val) {
      return val
    },
    textAnchor: 'start',
    horizontal: true,
  },
  xaxis: {
    categories: [
      'População IBGE',
      'População SISAB',
      'População e-SUS PEC',
      ['FCI atualizadas', 'e completas'],
      ['FCI desatualizadas', 'ou incompletas'],
      ['FCI meta semanal', 'de atualização'],
    ],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
  },
  markers: {
    size: 5,
  },

  colors: ['#9E9E9E', '#0000ff', '#0faee1', '#8fce02', '#ff2121', '#ffa500'],
}

export const municipioCircleOptions = {
  chart: {
    height: 200,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      hollow: {
        size: '50%',
      },
      dataLabels: {
        showOn: 'always',
        name: {
          show: false,
          offsetY: -15,
        },
        value: {
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: 10,
        },
      },
    },
  },

  colors: ['#a0d528'],
}

export const equipeBarOptions = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      distributed: true,
      horizontal: true,
    },
  },

  dataLabels: {
    enabled: true,
    offsetX: 50,
    style: {
      fontSize: '12px',
      colors: ['#000000'],
    },
    formatter: function (val) {
      return val
    },
    textAnchor: 'start',
    horizontal: true,
  },
  xaxis: {
    categories: [
      'População SISAB',
      'Cadastro mínimo',
      'População e-SUS PEC',
      'Cadastro máximo',
      ['FCI atualizadas', 'e completas'],
      ['FCI desatualizadas', 'ou incompletas'],
      ['FCI meta semanal', 'de atualização'],
    ],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
  },
  markers: {
    size: 5,
  },
  colors: [
    '#0000ff',
    '#669999',
    '#0faee1',
    '#cccc00',
    '#8fce02',
    '#ff2121',
    '#ffa500',
  ],
}

export const equipeCircleOptions = {
  chart: {
    height: 200,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      hollow: {
        size: '50%',
      },

      dataLabels: {
        showOn: 'always',
        name: {
          show: false,
          offsetY: -15,
        },
        value: {
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: 10,
        },
      },
    },
  },

  colors: ['#a0d528'],
}
export const acsBarOptions = {
  chart: {
    type: 'bar',
    height: 350,
  },
  plotOptions: {
    bar: {
      distributed: true,
      horizontal: true,
    },
  },

  dataLabels: {
    enabled: true,
    offsetX: 50,
    style: {
      fontSize: '12px',
      colors: ['#000000'],
    },
    formatter: function (val) {
      return val
    },
    textAnchor: 'start',
    horizontal: true,
  },

  /* xaxis: {
      categories: [
        '',
        '',
        '',
        '',
        ''
      ]
    }, */
  xaxis: {
    categories: [
      'População IBGE',
      'População e-SUS PEC',
      'Cadastros Atualizados',
      'Cadastros Desatualizados',
      'Cadastros a serem realizados',
      'Cadastros a serem atualizados (%)',
      ['Meta Semanal', 'de atualização'],
    ],
  },
  yaxis: {
    min: 0,
    max: 100,
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'left',
  },
  markers: {
    size: 5,
  },

  colors: ['#8fce02', '#ffb635', '#b194e7', '#ff2121', '#16b1e3', '#0faee1'],
}

export const acsCircleOptions = {
  chart: {
    height: 200,
    type: 'radialBar',
  },
  plotOptions: {
    labels: [],
    radialBar: {
      hollow: {
        size: '50%',
      },

      dataLabels: {
        showOn: 'always',
        name: {
          show: false,
          offsetY: -15,
        },
        value: {
          color: '#111',
          fontSize: '20px',
          show: true,
          fontWeight: 900,
          offsetY: 10,
        },
      },
    },
  },

  colors: [
    function ({ value, seriesIndex, w }) {
      if (value < 40) {
        return '#ff0000'
      } else {
        return '#00a4de'
      }
    },
  ],
}

export const groupFilterItems = [
  { label: 'Ativos', value: 'ativos' },
  { label: 'Outra equipe', value: 'outra-equipe' },
  { label: 'Óbitos', value: 'obitos' },
  { label: 'Mudou-se', value: 'mudou-se' },
  { label: 'Atendimento recente', value: 'atendimento-recente' },
]

export const infoHtml = `
<div id='write'  class=''><h4 id='cadastros-cidadãos'><strong><span>CADASTROS CIDADÃOS</span></strong></h4><hr /><p><span>O cadastro do cidadão no e-SUS APS é a base para as demais ações (indicadores de desempenho e registro eletrônico no prontuário do cidadão e outras). Recomenda-se que o cadastro seja realizado em primeiro lugar com o número do CPF e na falta do CPF, pode-se utilizar o número do CNS. </span></p><p><span>O cadastro vai para o e-SUS PEC ou Centralizador por três possibilidades: Digitação direta em </span><strong><span>PEC &gt;&gt; CDS &gt;&gt; Ficha de Cadastro Individual</span></strong><span> ou digitação direta em </span><strong><span>PEC &gt;&gt; Cidadão</span></strong><span> ou recebimentos de arquivos (lotes) que são importados de </span><strong><span>fontes externas</span></strong><span>. Os centralizadores do e-SUS APS recebem os cadastros sempre por importação de fontes externas.</span></p><p><span>Para qualificar um cadastro, precisa-se preencher a </span><strong><span>Ficha de Cadastro Individual (FCI)</span></strong><span> com CPF, data de nascimento, nome do cidadão, nome da mãe, INE da equipe, data da realização ou atualização do cadastro com dados corretos e revisados, bem como preencher também os demais campos.</span></p><p><span>O cadastro individual é como se fosse o censo da saúde, pois ele trata de informações do cidadão como: identificação do cidadão, informações sociodemográficas, condições ou situação de saúde gerais, se o cidadão está em situação de rua e possibilidade de termo de recusa do cadastro na Unidade de Saúde e por isso precisa estar sempre atualizado (recomenda-se que cada cadastro seja atualizado pelo menos uma vez por ano).</span></p><p><span>Uma base de cadastro bem qualificada e atualizada permite aos profissionais da equipe e aos gestores municipais de saúde obterem rapidamente e facilmente informações importantes para o planejamento e desenvolvimento das ações e serviços de saúde na APS.</span></p><p><span>Os cadastros a </span><strong><span>nível municipal</span></strong><span> e de </span><strong><span>equipe</span></strong><span> são todos aqueles registrados na </span><strong><span>Ficha de Cadastro Individual</span></strong><span> que é considerada a </span><strong><span>ficha completa</span></strong><span> ou </span><strong><span>Cadastros simplificado</span></strong><span> que é feito no </span><strong><span>módulo cidadão do e-SUS PEC</span></strong><span>. Em ambos os casos, é preciso ter o cadastro vinculado a alguma equipe do município, preferencialmente a equipe que está responsável pelo território onde o cidadão reside.</span></p><p><span>Os cadastros a </span><strong><span>nível de ACS</span></strong><span> ou </span><strong><span>micro área</span></strong><span> são provenientes da Ficha de Cadastro Individual, ou seja, a ficha completa que o ACS preenche ou então que é preenchida por outro profissional autorizado e que se coloca na ficha os dados de lotação do ACS.</span></p><p>&nbsp;</p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>Ao realizar o cadastro no e-SUS PEC ou CDS ou sistema privado, não se deve utilizar o CNS que está presente na Declaração de Nascido Vivo (DN ou DNV), pois não é um número válido e vai gerar a inconsistência de CNS não encontrado. Ao utilizar o CNS para cadastro, deve certificar-se que ele existe na base nacional do cartão nacional de saúde (CADSUS).</span></p><p><span>Cadastros com mudança de território (Sim), registro de data do óbito ou inativos no e-SUS PEC ou Centralizador, não ficam visíveis nesta tela. Esses cadastros podem ser consultados em </span><strong><span>INÍCIO &gt;&gt; Gestão cadastros &gt;&gt; Cidadão</span></strong><span>.</span></p></blockquote><p><span>  </span></p><h4 id='funcionalidades'><strong><span>FUNCIONALIDADES</span></strong></h4><hr /><p><span>Nesta tela você pode filtrar por </span><strong><span>Equipe</span></strong><span>, </span><strong><span>Profissional</span></strong><span> ACS ou </span><strong><span>Microárea</span></strong><span> que o cidadão está vinculado. </span></p><p><span>Tem a possibilidade de ver a </span><strong><span>Lista</span></strong><span> com os nomes dos cidadãos de acordo com o filtro selecionado, bem como o </span><strong><span>Resultado</span></strong><span> com dados consolidados e o </span><strong><span>Gráfico</span></strong><span> com a série histórica dos resultados.</span></p><p>&nbsp;</p><p><strong><span>Filtro por equipe e profissional ACS ou Microárea</span></strong></p><p><span>Os filtros de nível de visualização, quando estão disponíveis permite que você selecione uma equipe (</span><strong><code>Equipes</code></strong><span>) para visualizar os dados e depois possa escolher um </span><strong><code>Profissional</code></strong><span>, geralmente um Agente Comunitário de Saúde (ACS), ou possa escolher uma </span><strong><code>Microárea</code></strong><span>. </span></p><p><span>O menor nível a ser visualizado é o </span><strong><span>Profissional</span></strong><span> (pessoas vinculadas, geralmente ao CPF do ACS) ou a </span><strong><span>Microárea</span></strong><span> (valor utilizado para delimitar a menor porção territorial dentro da equipe).</span></p><p>&nbsp;</p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>Se você não está visualizando a possibilidade de escolher uma </span><strong><span>Equipe</span></strong><span>, então é porque o sistema já selecionou automaticamente a equipe que você tem vínculo.</span></p><p><span>Se você não está visualizando a possibilidade de escolher um </span><strong><span>Profissional</span></strong><span> ou </span><strong><span>Microárea</span></strong><span>, então é porque você está ativo com a lotação de Agente Comunitário de Saúde e o sistema automaticamente já selecionou os dados dos cidadãos que estão vinculados ao seu CPF no cabeçalho da Ficha de Cadastro Individual (FCI) ou sua Microárea.</span></p></blockquote><p><span> </span></p><p><span>Para acessar as demais funcionalidades, você pode clicar em </span><strong><code>Lista</code></strong><span>, </span><strong><code>Resultado</code></strong><span> ou </span><strong><code>Gráfico</code></strong><span>. Isso permite um acesso fácil e visualização rápida.</span></p><p>&nbsp;</p><p><strong><span>Lista</span></strong></p><hr /><p><span>A lista apresenta a relação nominal dos usuários cadastrados de acordo com o nível de visualização escolhido por você. </span><strong><span>Por exemplo:</span></strong><span> quando se seleciona a equipe e um profissional, então os dados em tela são dos cidadãos cadastrados com o INE da equipe selecionada e com o CPF do profissional escolhido ou micro área.</span></p><p>&nbsp;</p><p><strong><span>Filtro por idade ou faixa etária</span></strong></p><p><span>O filtro </span><strong><span>De</span></strong><span> </span><em><code>Idade</code></em><span> </span><strong><span>a</span></strong><span> </span><em><code>Idade</code></em><span> permite que você informe uma faixa etária entre dois valores em anos. </span><strong><span>Por exemplo:</span></strong><span> 0 a 5 e o sistema vai te mostrar apenas as pessoas que têm entre 0 e 5 anos de idade. </span></p><p>&nbsp;</p><p><strong><span>Filtro por sexo</span></strong></p><p><span>O filtro </span><strong><code>Sexo</code></strong><span> permite a você escolher se deseja visualizar masculino, feminino ou todos. Ele pode ser combinado com o filtro de visualização por idade.</span></p><p>&nbsp;</p><p><strong><span>Filtro cidadãos Atualizados ou Desatualizados</span></strong></p><p><span>Quando você marcar o botão </span><strong><code>Desatualizado</code></strong><span>, então estará visualizando as pessoas que estão com cadastro desatualizados há mais de 1 ano. Se você marcar o botão </span><strong><code>Atualizado</code></strong><span>, vai ser mostrado em tela as pessoas que estão com cadastro atualizado dentro do último ano.</span></p><p>&nbsp;</p><p><strong><span>Baixar ou fazer o download da lista</span></strong></p><p><span>Se você desejar, pode baixar estes dados em formato </span><strong><span>PDF</span></strong><span> ou </span><strong><span>XLS</span></strong><span>. Para isso, basta clicar no botão </span><strong><code>EXPORTAR</code></strong><span>.</span></p><p>&nbsp;</p><p><strong><span>Pesquisar pelo nome do cidadão</span></strong></p><p><span>Para pesquisar um determinado cidadão, você pode digitar em </span><strong><code>Nome do cidadão</code></strong><span> e será mostrado somente os cidadãos que contém o termo digitado na caixa de pesquisa.</span></p><p>&nbsp;</p><p><strong><span>Filtro Grupos</span></strong></p><ul><li><p><strong><span>Ativos</span></strong><span> - cidadãos com último cadastro em PEC &gt;&gt; CDS &gt;&gt; Cadastro Individual, vinculado ao CPF do ACS e equipe atual que o profissional pertence;</span></p></li><li><p><strong><span>Outra equipe</span></strong><span> - cidadãos que estão vinculados ao CPF do ACS, mas pertence a equipe anterior onde o ACS esteve atuando;</span></p></li><li><p><strong><span>Óbitos</span></strong><span> - cidadãos falecidos enquanto estavam na micro área do ACS;</span></p></li><li><p><strong><span>Mudou-se</span></strong><span> - cidadãos com último cadastro em PEC &gt;&gt; CDS &gt;&gt; Cadastro Individual, vinculado ao CPF do ACS e equipe atual que o profissional faz parte e está com &quot;Mudança de território&quot; ativa no cadastro;</span></p></li><li><p><strong><span>Atendimento recente</span></strong><span> - cidadãos com último cadastro em PEC &gt;&gt; CDS &gt;&gt; Cadastro Individual, vinculado ao CPF do ACS e equipe atual que o profissional faz parte, está com &quot;Mudança de território&quot; ativa no cadastro, no entanto </span><strong><span>foi atendido por profissional de nível superior no serviço municipal da APS após a mudança de território</span></strong><span>.</span></p></li></ul><p>&nbsp;</p><blockquote><p><span>ATENÇÃO!</span></p><p><span>Cidadãos que estão no filtro </span><strong><span>Atendimento recente</span></strong><span> devem ter seu cadastro atualizado, pois estão ativos no território:</span></p><ul><li><p><span>Se o cidadão reside no município, em micro área com ACS, então o mesmo atualiza o cadastro.</span></p></li><li><p><span>Nos casos em que o cidadão não reside no município, mas busca constantemente a assistência municipal na APS ou reside em micro área que não tem ACS, então a atualização do cadastro pode ser feita pelos profissionais da equipe (Recepcionistas, Enfermagem ou Medicina) no momento do atendimento.</span></p></li></ul></blockquote><p>&nbsp;</p><p><strong><span>Tabela de dados</span></strong></p><p><span>A tabela de dados permite ordenação em formato crescente e decrescente por coluna e apresenta as seguintes informações:</span></p><ul><li><p><strong><span>Nome</span></strong><span> – nome do cidadão ou cidadã. No e-SUS, deve ser preenchido com as informações igual está no CPF;</span></p></li><li><p><strong><span>Nascimento</span></strong><span> – data de nascimento do cidadão. Data de nascimento do cadastro diferente da que está na receita federal inválida o cadastro com a inconsistência de data de nascimento divergentes;</span></p></li><li><p><strong><span>Idade</span></strong><span> – a idade que o cidadão tem hoje em anos;</span></p></li><li><p><strong><span>Mãe</span></strong><span> – nome da mãe do cidadão informado no cadastro;</span></p></li><li><p><strong><span>MA</span></strong><span> – Número da micro área informado no cadastro do cidadão;</span></p></li><li><p><strong><span>Atualizado em</span></strong><span> – data da última atualização do cadastro do cidadão.</span></p></li></ul><p><span>Para visualizar </span><strong><span>CPF</span></strong><span> e </span><strong><span>CNS</span></strong><span>, basta clicar no botão do final da linha para expandir o registro.</span></p><p>&nbsp;</p><p><strong><span>Fonte dos dados</span></strong></p><p><span>A </span><strong><span>Fonte</span></strong><span> mostra a origem dos dados e em qual data eles foram processados. Para um monitoramento preciso e identificação das informações mais recentes. A data na </span><strong><span>fonte</span></strong><span> dos dados aqui precisa estar o mais próximo do hoje possível. Se você tem cadastros realizados depois da data que o sistema está mostrando aqui, então acionar o suporte para avaliarmos porque a sincronização não está acontecendo.</span></p><p><span>Para visualizar a quantidade de pessoas de acordo com o filtro escolhido, pode-se olhar para a informação do lado inferior direito da tabela os dois primeiros números referem-se a página atual e o terceiro número indica o total. As setas indicando direita e esquerda servem para navegar entre os registros da tabela de dados que mostra 10 registros de cada vez.</span></p><p>&nbsp;</p><p><strong><span>Resultados</span></strong></p><hr /><p><span>O resultado refere-se ao cálculo da quantidade de cadastros que estão vinculados ao município, equipe selecionada ou ACS (considera todos os cadastros que têm na última ficha FCI do cidadão, o cabeçalho assinado com o CPF e dados de lotação do profissional ACS).</span></p><p>&nbsp;</p><p><strong><span>Tabela de dados</span></strong></p><p><span>A </span><strong><code>Tabela</code><span> de dados do Resultado</span></strong><span> apresenta as colunas:</span></p><ul><li><p><strong><span>Por</span></strong><span> – </span><em><span>município</span></em><span> (quantidade de cadastros no município), </span><em><span>equipe</span></em><span> (quantidade de cadastros vinculados ao INE da equipe selecionada) e </span><em><span>ACS</span></em><span> (quantidade de cidadãos com o CPF do ACS selecionado enquanto profissional cadastrante da última ficha registrada do cidadão no e-SUS APS);</span></p></li><li><p><strong><span>Atualizados</span></strong><span> – dentre o total de cadastros (por município, equipe ou ACS), representa o percentual que está atualizado dentro do último ano;</span></p></li><li><p><strong><span>Desatualizados</span></strong><span> – mostra o percentual de cadastros desatualizados no município, na equipe ou no ACS, selecionado. São considerados cadastros desatualizados aqueles que estão com mais de um ano desde que a última atualização foi realizada.</span></p></li></ul><p>&nbsp;</p><p><strong><span>Fórmula do cálculo do resultado</span></strong></p><p><span>O cálculo dos cadastros atualizados é feito pegando-se o total de cadastros atualizados, dividindo pelo total de cadastros e multiplicando por 100. Esse cálculo leva em consideração cada nível de visualização.</span></p><p>&nbsp;</p><p><strong><span>Fonte dos dados</span></strong></p><p><span>A </span><strong><span>Fonte</span></strong><span> mostra a origem dos dados e a data da última sincronização aqui com o sistema de Monitoramento e Avaliação na APS.</span></p><p>&nbsp;</p><blockquote><p><strong><span>ATENÇÃO</span></strong></p><p><span>Ao fazer </span><strong><span>a média</span></strong><span> dos cadastros dos </span><strong><span>resultados das equipes</span></strong><span>, a média vai ser diferente do resultado municipal. A </span><strong><span>média</span></strong><span> dos </span><strong><span>resultados dos cadastros dos ACS</span></strong><span> vai ser </span><strong><span>diferente do resultado mostrado na equipe</span></strong><span>. </span></p><p><span>Isso acontece, pois têm cadastros que estão vinculados ao município, mas não tem um vínculo com qualquer equipe, assim como têm cadastros que estão vinculados às equipes e não tem um ACS responsável pelo preenchimento da Ficha de Cadastro Individual.</span></p></blockquote><p><span> </span></p><p><strong><span>Gráfico</span></strong></p><p><span>O </span><strong><code>Gráfico</code><span> do Resultado</span></strong><span> trata das seguintes informações legendadas: População IBGE, População SISAB, População e-SUS PEC, Cadastros Atualizados, Cadastros desatualizados, Meta semanal de atualização, resultado em porcentagem e Diferença entre o resultado do mês anterior e o mês atual.</span></p><p><span>Clicando nas setas para a direita e para a esquerda é possível navegar entre os níveis: Município, Equipe e ACS de acordo com o filtro selecionado.</span></p><p><span>Para interpretar o resultado do gráfico de barras horizontais (pelo nível de visualização), considera-se:</span></p><ul><li><p><strong><span>População IBGE</span></strong><span> - população estimada pelo IBGE para o município;</span></p></li><li><p><strong><span>População SISAB</span></strong><span> - população cadastrada e enviada para o SISAB;</span></p></li><li><p><strong><span>População e-SUS PEC</span></strong><span> - população com cadastro realizado no e-SUS PEC ou Centralizador municipal;</span></p></li><li><p><strong><span>Cadastros Atualizados</span></strong><span> - cadastros que estão com atualização a menos de um ano;</span></p></li><li><p><strong><span>Cadastros desatualizados</span></strong><span> - cadastros que estão há mais de um ano sem atualização;</span></p></li><li><p><strong><span>Meta semanal de atualização</span></strong><span> - quantidade de cadastros a serem atualizados por semana para concluir a atualização de todos os cadastros dentro do quadrimestre.</span></p></li></ul><p><span>O </span><strong><span>gráfico de rosca</span></strong><span> representa o resultado percentual de cadastros atualizados em relação ao total de cadastros de acordo com o nível selecionado.</span></p><p><span>O </span><strong><span>emoticon ou emoji</span></strong><span> analisa a diferença de resultado entre o mês atual e o mês anterior e fica:</span></p><ul><li><p><strong><span>Feliz</span></strong><span> - quando a diferença é positiva (verde);</span></p></li><li><p><strong><span>Chateado</span></strong><span> - quando a diferença é zero (laranja);</span></p></li><li><p><strong><span>Triste</span></strong><span> - quando a diferença é negativa (vermelho).</span></p></li></ul><p>&nbsp;</p><p><strong><span>Gráfico</span></strong></p><hr /><p><span>O gráfico mostra a série histórica ao longo do tempo para a visualização sobre se os resultados de cadastros atualizados: melhoraram (linha crescente), pioraram (linha caindo) ou se mantiveram estáveis (linha reta).</span></p><p><span>As cores representam a que nível pertence a informação (Município, Equipe ou ACS).</span></p><p><span>Ao passar o mouse ou fazer gesto sobre o gráfico, aparece as informações de quantidade e nível de acordo com o mês que fica abaixo do gráfico.</span></p><p><span>Caso você deseje fazer o download ou baixar (SVG, PNG ou CSV) os dados do gráfico, basta clicar nos três pontinhos do lado direito superior dele. </span></p><p>&nbsp;</p><p><strong><span>Fonte dos dados</span></strong></p><p><span>A </span><strong><span>Fonte</span></strong><span> mostra a origem dos dados e a data da última sincronização aqui com o sistema de Monitoramento e Avaliação na APS.</span></p></div>`
